import React from "react";
import NavBar from "./NavBar";
import UserSideBar from "./UserSideBar";
import Button from "react-bootstrap/Button";
import "./logout.css";
import { useDispatch } from "react-redux";
import { logout } from "../Redux/userSlice";
import { removeCart } from "../Redux/shoppingCartSlice";
import { useNavigate } from "react-router-dom";

function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const out = () => {
    dispatch(removeCart());
    dispatch(logout());
    navigate("/");
  };

  return (
    <>
      <NavBar />
      <div style={{ marginTop: "7rem" }} className="container">
        <div className="row ">
          <div className="col-8 col-lg-3 mb-5">
            <UserSideBar />
          </div>
          <div className="col-12 col-lg-9 d-flex flex-column align-items-center logout">
            <p>Are you sure you want to log out?</p>
            <Button onClick={() => out()} variant="dark">
              Yes
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Logout;
